import { render, staticRenderFns } from "./EditarLicenciaDialogCmponent.vue?vue&type=template&id=67d80b54&scoped=true"
import script from "./EditarLicenciaDialogCmponent.vue?vue&type=script&lang=js"
export * from "./EditarLicenciaDialogCmponent.vue?vue&type=script&lang=js"
import style0 from "./EditarLicenciaDialogCmponent.vue?vue&type=style&index=0&id=67d80b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d80b54",
  null
  
)

export default component.exports